//import { LoadAllCategoriesResponseData } from '@/apis/tagging';

import { BusinessNoteAction } from "./notes";
import { GoogleBusiness, BusinessInterestType as BusinessInterestTypeTagging } from "./tagging";
import User from "./user";

export interface NearbyBusinessData {
  id: number;
  business_id: number;
  business_nearby_category_id: number;
  nearby_business_id: number;
  added_by: number;
  business_nearby_category_title: string;
  business_type: string;
  created_at: string;
  updated_at: string;
}

export enum VenuePinType {
  Grey = "grey",
  Blue = "blue",
  Orange = "orange",
  Black = "black",
  Green = "green",
  Purple = "purple",
}

export interface Venue {
  id: string;
  placeId: string;
  name: string;
  phone: string;
  website: string;
  address: string;
  latitude: number;
  longitude: number;
  rating: number;
  types: string;
  keepUpdated: number;
  businessStatus: string;
  what3words: any;
  sociabilityVerified: number;
  openNow: string;
  reviewDetailsSubmitted: number;
  tagIds: string;
  detailsFetchedAt: string;
  placeidCheckedAt: string;
  googlePhotosCount: number;
  sociabilityVisible: number;
  city: string;
  cityLocation: string;
  openCloseStatus: string;
  notExistCount: number;
  bluePinsCount: number;
  distance: string;
  userDistance: string;
  openingHours: OpeningHour[];
  taggingCategories: string;
  reviewsDetailsSubmitted: number;
  reviewsSubmitted: number;
  photo: string;
  photoThumb: string;
  altText: string;
  businessBadges: any;
  hasNotesForMappers: any;
  isRejectedMapperNote: boolean;
  isNotExistMapperNote: boolean;
  brandName: string;
  brandId: string;
  googleReviewsCount: number;
  businessType: string;
  business: Business;
  reviews: Review[];
  details?: VenueDetails;
  loadAllCategoriesResponseData?: any | undefined | null;
  venuePinType?: VenuePinType;
  latestReviewDateUpdated: string;
  to_be_verified: number;
  calcVenueType?: string;
  isNoteStatusPending: number;
  isReturnToVenue: number;
  nearbyBusinessData?: NearbyBusinessData;
  nearby_venues_count: number;
  businessInterest?: BusinessInterestTypeTagging;
}

export interface OpeningHour {
  googleBusinessId: string;
  day: number;
  openTime: number;
  closeTime: number;
  id: number;
  utcOffset: number;
  openTimeUtc: number;
  closeTimeUtc: number;
  createdAt: string;
  updatedAt: string;
  mode: number;
}

export interface Business {
  id: number;
  googleBusinessId: string;
  deletedAt: any;
  createdAt: string;
  updatedAt: string;
  foursquareId: string;
  foursquareUpdatedAt: string;
  userId: any;
  brandId: any;
  slug: string;
  venueTypeId: any;
  templateId: any;
  description: any;
  subDescription: any;
  allowSpaceFlagging: number;
  allowSpaceReview: number;
  themeName: any;
  themeLogo: any;
  themeEmail: any;
  themeDownloadAppLink: any;
  qrCode: string;
  businessType: string;
  imageExistChecked: number;
  isPasswordProtect: number;
  isStopSearchEngine: number;
  siteMapPhoto: any;
  externalLinkTitle: any;
  externalLinkUrl: any;
  isSsoProtect: number;
  ssoTenantId: any;
  hqChecked: number;
  hqCheckedByUserId: any;
  hqCheckedAt: string;
  completeness: string;
  missingAreas: string;
  complexCacheUpdatedAt: string;
  google_business?: GoogleBusiness;
  transportOptionImage: string;
  transportOptionText: string;
  publicUrl: string;
  venue_summary: string;
  isComplex: number;
}

export interface Review {
  googleBusinessId: string;
  authorName: string;
  authorUrl: string;
  language: string;
  profilePhotoUrl: string;
  rating: number;
  text: string;
  time: string;
}

export interface BusinessTabImage {
  id: number;
  image_path: string;
  alt_text: string;
  order: number;
}

export interface BusinessTab {
  id: number;
  title: string;
  subtitle?: string;
  content: string;
  order: number;
  images: BusinessTabImage[];
}

export interface VenueDetails {
  id: string;
  placeId: string;
  name: string;
  phone: any;
  website: string;
  description: string;
  address: string;
  latitude: number;
  longitude: number;
  rating: number;
  types: string;
  keepUpdated: number;
  latestReviewDateUpdated: string;
  businessStatus: string;
  what3Words: any;
  sociabilityVerified: number;
  openNow: string;
  reviewDetailsSubmitted: number;
  tagIds: string;
  detailsFetchedAt: string;
  placeidCheckedAt: string;
  googlePhotosCount: number;
  sociabilityVisible: number;
  city: string;
  cityLocation: string;
  business: Business;
  allLikesData: any[];
  brandName: string;
  brandId: string;
  likesCount: number;
  dislikesCount: number;
  disabilityTrainedStaff: number;
  businessPhotoCount: number;
  businessPhotoFirst: BusinessPhotoFirst;
  businessNotices: VenueNotice[];
  googleReviewsCount: number;
  openingHours: OpeningHour[];
  businessBadges: string;
  populartimeCount: number;
  popularTimeData: PopularTimeDatum[];
  businessAccessibilityVerifiedBadge: string;
  businessType: string;
  tagAppliedOptions: TagAppliedOption[];
  businessPhotos: BusinessPhoto[];
  templateTypeCategoriesCount: number;
  distance: string;
  showBusinessNotesDataForMapper: boolean;
  businessNotesForMappers: MapperNotes[];
  businessNotesAll: businessNotesAll[];
  enableSendToMobile: boolean;
  photoAltTextTemplate: PhotoAltTextTemplate;
  templateType: string;
  isPublicTemplate: string;
  businessReviews: VenueReview[];
  businessSpaceReviews: any[];
  nearbyBusinessCategories: any[];
  filterAccessibility: any[];
  nearbyBusinessCategoriesCount: number;
  isStopSearchEngine: number;
  businessSavedByUser: boolean;
  isNoteStatusPending: number,
  isReturnToVenue: number,
  businessVenueNotesAreaLocations: VenueNotesAreaLocations[],
  businessNotesActionsVenueNotes: VenueNotesAction[],
  businessNoteHeadingSuggestions: BusinessNoteHeadingSuggestion[],
  businessNotesActions: BusinessNoteAction[],
  businessSociabilitySaysPending: businessNotesAll[],
  siteMapPhoto: any;
  transportOptionImage: string;
  transportOptionText: string;
  businessClaimData: BusinessClaimData[];
  hasNearbyVenues: boolean;
  businessInterestsTypes: BusinessInterestTypeSmall[];
  businessInterestData: BusinessInterestData[];
  businessTabs: BusinessTab[];
  cohortsData?: CohortData[];
  businessSlugDetails?: BusinessSlugDetails;
  isComplex: number;
  publicUrl: string;
  userDistance: string;
  venueAccessibilityExperienceStats?: VenueAccessibilityExperienceStats;
}

export interface VenueAccessibilityExperienceStats {
  coolCount: number;
  coolPercentage: number;
  totalCount: number;
  weirdCount: number;
  weirdPercentage: number;  
}

export interface BusinessClaimData {
  id: number;
  name: string;
  email: string;
  phone: string;
  description: string;
  created_at: string;
  user_id?: number;
}

export interface BusinessSlugDetails {
  slug: string;
  visibility: string;
  visibility_type: "general" | "walkthrough" | string;
}

export interface CohortData {
  cohort_id: number;
  business_id: number;
  cohort_name: string;
  visibility_type: string;
  start_date: string | null;
  end_date: string | null;
  visibility_photo: string | null;
  alt_text: string | null;
  slug_title: string;
  slug: string;
  spaces_count: number;
}

export interface BusinessInterestTypeSmall {
  name: string;
  value: string;
}

export interface BusinessInterestData {
  id: number;
  business_id: number;
  user_id: number;
  interested_type: string;
  notify_accessibility_information: number;
  notify_live_alert: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  user: {
    id: number;
    name: string;
    email: string;
  };
}

export interface VenueNotice {
  id: number
  business_id: number
  sub_title: string
  title: string
  description: string
  start_date: string
  end_date: string
  path: string
  path_thumb: string
  type: string
  review_level_id: number
}

export interface VenueNotesAreaLocations {
  id: string
  name: string
  location_type: string
  tags: {
    id: number
    name: string
    location_type: string
  }[]
}

export interface VenueNotesAction {
  id: number
  title: string
  subtitle: string
  external_link: any
  description: string
  display_order: number
  hq_approval_for_delete: number
  can_edit: number
  can_resolve: number
  show_tasks: number
  isNoteTextMandatory: number
}

export interface BusinessNoteHeadingSuggestion {  
  business_notes_action_id: number;
  display_order: number;
  heading: string;
  area_ids_allowed:string;
  id: number;  
  allowNoteValidity: number;
}

export interface BusinessPhotoFirst {
  businessId: number;
  reviewPhotosId: number;
  userId: number;
  path: string;
  reviewId: number;
  reviewDetailId: any;
  typeId: number;
  altText: string;
  tagApplied: string;
  reviewLevelId: number;
  coverPhoto: number;
  createdAt: string;
  sortOrder: number;
  userName: string;
  reviewLevel: any;
  photoType: string;
  tagCategories: string;
  tagAppliedForOrderby: string;
}

export interface PopularTimeDatum {
  weekday: string;
  value: number;
  hour: string;
}

export interface TagAppliedOption {
  optionTitle: string;
  optionValue: string;
  option: string;
}

export interface BusinessPhoto {
  businessId: number;
  reviewPhotosId: number;
  userId: number;
  path: string;
  reviewId: number;
  reviewDetailId?: number;
  typeId: number;
  altText?: string;
  tagApplied: string;
  reviewLevelId?: number;
  coverPhoto: number;
  createdAt: string;
  sortOrder: number;
  userName: string;
  reviewLevel: any;
  photoType: string;
  tagCategories: string;
  tagAppliedForOrderby: string;
  tagName: string;
  width: number;
  height: number;
  alt_text?: string;
  created_at?: string;
  user_name?: string;
  category_name?: string;
  user_roles?: {
    isGeneralUser: boolean;
  };
}

export interface PhotoAltTextTemplate {
  photoAltTextTemplate: PhotoAltTextTemplate2;
}

export interface PhotoAltTextTemplate2 {
  "Entrances & Exits": string;
  "Indoor Areas": string;
  "Outdoor Areas": string;
  Bathroom: string;
  "Visual, hearing & sensory": string;
  "Fitting Rooms": string;
  "Lifts & Stairs": any;
  "Bathroom Facilities": any;
}

export interface BusinessReportIssueAction {
  id: number;
  title: string;
  externalLink?: string;
}

export interface BusinessNoteVote {
  id: number;
  type: "Ongoing" | "Resolved";
  user: {
    id: number;
    name: string;
  };
  details: string;
  photos: string[];
  created_at: string;
}

export interface businessNotesAll {
  action_by_user: string;
  action_by_user_id: number;
  action_color: string;
  action_done_at: string;
  action_title: string;
  business_name: string;
  business_note_title: string;
  business_note_added_at: string;
  business_note_by_user: string;
  business_note_by_user_id: number;
  business_note_text: string|null;
  business_note_text_id: number;
  business_notes_action_id: number;
  created_at: string;
  expiry_at: number;
  formatedActionDoneAt: string;
  formatedCreatedAt: string;
  formatedScheduleDateFrom: string;
  formatedScheduleDateTo: string;
  id: number;
  location_id: number;
  location_name: string;
  location_type: string;
  note_type: string;
  review_details_submitted: number;
  schedule_date_from: string;
  schedule_date_to: string;
  status: string;
  action_on_date: string;
  return_on_date: string;
  userName: string;
  business_note_heading_suggestions_id: number;
  business_note_heading_suggestions_placeholder_text: string;
  votes?: BusinessNoteVote[];
  business_note_by_user_roles?: {
    isSociabilityTeam: boolean;
    isSociabilityMapper: boolean;
    isDerbyUser: boolean;
    isAiAccessUser: boolean;
    maxPhotoUploadAllowedByRole: string;
  };
}

export interface VenueReview {
  totalReviewDetails: number;
  likesCount: number;
  dislikesCount: number;
  flaggedReviews: number;
  categoryName: string | null;
  id: number;
  userId: number;
  businessId: number;
  notes: string;
  status: number;
  deletedAt: null | string;
  createdAt: string;
  updatedAt: string;
  ownerNotes: null | string;
  reviewType: number;
  adminOverride: number;
  adminUserId: null | number;
  adminOverrideAt: null | string;
  timeAgo: string;
  user: any;
  userDisabilityVisible: string;
  userFirstName: string;
  userLastName: string;
  userProfilePhoto: string;
  userProfileColorCode: string;
  userAbility: string;
  user_disability_visible: string;
  accessibility_experience: string | null;
  reviewPhotos: ReviewPhoto[];
}

export interface ReviewPhoto {
  id: number;
  userId: number;
  businessId: number;
  path: string;
  pathThumb: string;
  typeId: number;
  reviewId: number;
  createdAt: string;
  updatedAt: string;
  reviewDetailId: number | null;
  altText: string;
  tagApplied: string;
  reviewLevelId: number | null;
  coverPhoto: number;
  sortOrder: number;
  width?: number;
  height?: number;
  tag_name?: string;
  alt_text: string;
  tag_applied: string;  
  sort_order?: number;
  created_at?: string;
  user_id?: number;
  business_id?: number;
  path_thumb?: string;
  type_id?: number;
  review_id?: number;
  review_detail_id?: number | null;
  review_level_id?: number | null;
  cover_photo?: number;
  user_roles?: {
    isGeneralUser: boolean;
  };
}

export interface MapperNotes {
  business_notes_action_id: number; 
  issueId: number;
  issue_id: number;
  notes: string;
  businessReportIssueActionsId: number | null;
  createdAt: string;
  userName: string;
  userId: number;
  status: number;
  actionTitle: string | null;
  actionDoneAt: string;
  formattedCreatedAt: string;
  formattedActionDoneAt: string;
  rejectedMapping: number;
  notExist: number;
  created_at: string;
  return_on_date: string;
  action_on_date: string;
  formatedReturnOnDate: string;
  formatedActionOnDate: string;
  isReturnToVenue: number;
  isNoteStatusPending: number;
  action_title: string;
  can_edit: number;
  can_resolve: number;
  show_tasks: number;
  location_id: number;
  location_name: string;
  location_type: string;
  isNoteTextMandatory: number;
}

export interface Notices {
  business_id: number;
  description: string;
  end_date: string;
  id: number;
  path: string;
  path_thumb: number;
  review_level_id: number;
  start_date: string;
  sub_title: string;
  title: string;
  type: string;
  formatedReturnOnDate?: string;
}

export type AddPhotoImageData = {
  imageUrl: string;
  note: string;
  selectedOption: string;
  key: string;
};

export function venueFromDetail(detail: VenueDetails): Venue {
  return {
    id: detail.id,
    placeId: detail.placeId,
    name: detail.name,
    phone: detail.phone,
    website: detail.website,
    address: detail.address,
    latitude: detail.latitude,
    longitude: detail.longitude,
    rating: detail.rating,
    types: detail.types,
    keepUpdated: detail.keepUpdated,
    businessStatus: detail.businessStatus,
    what3words: detail.what3Words,
    sociabilityVerified: detail.sociabilityVerified,
    openNow: detail.openNow,
    reviewDetailsSubmitted: detail.reviewDetailsSubmitted,
    tagIds: detail.tagIds,
    detailsFetchedAt: detail.detailsFetchedAt,
    placeidCheckedAt: detail.placeidCheckedAt,
    googlePhotosCount: detail.googlePhotosCount,
    sociabilityVisible: detail.sociabilityVisible,
    city: detail.city,
    cityLocation: detail.cityLocation,
    openCloseStatus: detail.openNow,
    notExistCount: 0,
    bluePinsCount: 0,
    distance: detail.distance,
    userDistance: detail.userDistance,
    openingHours: detail.openingHours,
    taggingCategories: detail.tagAppliedOptions
      .map((tag) => tag.option)
      .join(", "),
    reviewsDetailsSubmitted: 0,
    reviewsSubmitted: 0,
    photo: "",
    photoThumb: "", // Add missing property
    altText: "", // Add missing property
    businessBadges: [], // Add missing property
    hasNotesForMappers: false, // Add missing property
    isRejectedMapperNote: false, // Add missing property
    isNotExistMapperNote: false, // Add missing property
    brandName: detail.brandName,
    brandId: detail.brandId,
    googleReviewsCount: detail.googleReviewsCount,
    businessType: detail.businessType,
    business: detail.business,
    reviews: [],
    details: detail,
    latestReviewDateUpdated: detail.latestReviewDateUpdated,
    to_be_verified: 0,
    isNoteStatusPending: detail.isNoteStatusPending,
    isReturnToVenue: detail.isReturnToVenue,
    nearby_venues_count: detail.nearbyBusinessCategoriesCount,

  };
}
